import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import jwt_decode from 'jwt-decode';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Login } from '../_models/login';
import { BehaviorSubject } from 'rxjs';
import { Token } from '../_models/token';
import { Sessao } from '../_models/sessao';

const KEY = 'polivias-carreteiro-admin-authToken';

@Injectable({
    providedIn: 'root',
})
export class TokenService {

    hasError: boolean = false;

    token!: Token | undefined;

    private sessionSubject = new BehaviorSubject<Token | undefined | null>(null);

    constructor(private http: HttpClient) { }

    hasToken() {
        return !!this.getToken() && !this.isTokenExpired();
    }

    setToken(login: Login) {

        return this.http.post<Sessao>(`${environment.URL_API}/user/login`, login,
            ).pipe(
                tap(res => {
                    localStorage.setItem(KEY, res.token);
                    //this.decodeAndNotify();
                })
            );
    }

    refreshToken() {
        return this.http.post(`${environment.URL_API}/Token/RefreshToken`,
            null,
            { responseType: "text" }).pipe(
                tap(res => {
                    localStorage.setItem(KEY, res);
                    this.decodeAndNotify();
                })
            );
    }

    getToken() {
        return localStorage.getItem(KEY);
    }

    getTokenExpirationDate(token: string | null): Date | null {
        if(token == null ) return null;
        
        const decoded = jwt_decode(token) as any;

        if (decoded.exp === undefined) return null;

        const date = new Date(0);
        date.setUTCSeconds(decoded.exp);
        return date;
    }

    logout() {
        this.removeToken();
    }

    removeToken() {
        this.token = undefined;
        localStorage.removeItem(KEY);
        this.sessionSubject.next(undefined);
    }

    getTokenSuccess(token: string) {
        localStorage.setItem(KEY, token);
    }

    getTokenError(err: any) {
        this.hasError = true;
        console.log('erro obtendo o token: ' + err);
    }

    isTokenExpired() {
        let token = this.getToken();
        if(!token) return true;

        const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
        return (Math.floor((new Date).getTime() / 1000)) >= expiry;
      }


    get email():string {
        if (!this.token)
            this.decodeAndNotify();

        return this.token!.email;
    }

    get name():string {
        if (!this.token)
            this.decodeAndNotify();

        return this.token!.Name;
    }

    get id():string {
        if (!this.token)
            this.decodeAndNotify();

        return this.token!.Id;
    }

    get profileCode():string {
        if (!this.token)
            this.decodeAndNotify();

        return this.token!.ProfileCode.toUpperCase();
    }

    get refreshChecklist(): boolean {
        if (!this.token)
            this.decodeAndNotify();

        const token = this.token as any;
        const value = token?.refreshChecklist ?? token?.RefreshChecklist ?? token?.refreshchecklist;
        return value === true || value === 'true' || value === 'True' || value === 1 || value === '1';
    }

    get addDriver(): boolean {
        if (!this.token)
            this.decodeAndNotify();

        const token = this.token as any;
        const value = token?.addDriver ?? token?.AddDriver ?? token?.adddriver;
        return value === true || value === 'true' || value === 'True' || value === 1 || value === '1';
    }

    private decodeAndNotify() {
        try {
            const token = this.getToken();

            if (!token) return;

            const jwtDecoded = jwt_decode(token) as Token;
            this.token = jwtDecoded;
            this.sessionSubject.next(this.token);
        }

        catch (e) {
            this.logout();
        }
    }
}
